<template>
    <div>
        <input type="file" class="filestyle" :accept="accept" @change="previewFiles" />
    </div>
</template>

<script>
import "bootstrap-filestyle/src/bootstrap-filestyle";
 
export default {
    props: ["value", "accept"],
    mounted: function () {
        $(this.$el).find("input").filestyle({
            buttonName: "btn-default btn-social",
            buttonText: "Upload",
            iconName: "fas fa-folder-open",
            input: true,
            placeholder: "Selecione o Arquivo."
        });
    },
    methods: {
        previewFiles(event) {
            const vm = this;
            var files = event.target.files;
            var file = files[0];

            if (files && file) {
                var reader = new FileReader();

                reader.onload = function() {
                    vm.$emit("input", file);
                };
                reader.readAsDataURL(file);
            }
        }
    },
    destroyed: function () {
         $(this.$el).find("input").filestyle("destroy");
    }
};
</script>